import { anodum } from '@yola/ws-sdk';

const isElementColumn = (element) => !!element && anodum.isTag(element, 'ws-column');

export default isElementColumn;
